export default __webpack_public_path__ + "static/media/search.d0561722.svg";